import React, { useContext, useState } from 'react';
import ModalModule from '../modal';
import Utils from '../utils';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { Logger, Communication } = Utils;

const DeleteCostCodesModal = ({ data, modalId }) => {
	const { customerId, costCodes, onSuccess } = data;
	const { showError, closeModal } = useContext(ModalContext);
	const [isDisabled, setIsDisabled] = useState(false);

	const deleteCostCodes = async () => {
		// disabled "Yes" button
		setIsDisabled(true);

		const response = await Communication.deleteCostCodes(costCodes, customerId);

		if (Communication.isSuccessful(response)) {
			onSuccess();
		} else {
			showError({ response });
		}

		Logger.saveActionData('Delete Cost Codes Button Clicked');

		closeModal(modalId);
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Yes',
		onClick: deleteCostCodes,
		disabled: isDisabled,
		dataqa: 'delete-cost-code-yes-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'No',
		dataqa: 'delete-cost-code-no-button',
	};

	const renderText =
		costCodes.length === 1
			? 'Delete this Cost Code?'
			: `Delete ${costCodes.length} Cost Codes?`;

	return (
		<Modal
			modalId={modalId}
			className="common-cost-codes delete-cost-codes-modal warning-modal"
			header={`Delete Cost Code${costCodes.length > 1 ? 's' : ''}`}
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<div className="body">
				<p>{renderText}</p>
			</div>
		</Modal>
	);
};

export default DeleteCostCodesModal;
